import { render } from "./ListItemRsolNoticia.vue?vue&type=template&id=73648cae&scoped=true"
import script from "./ListItemRsolNoticia.vue?vue&type=script&lang=js"
export * from "./ListItemRsolNoticia.vue?vue&type=script&lang=js"

import "./ListItemRsolNoticia.vue?vue&type=style&index=0&id=73648cae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73648cae"]])

export default __exports__